import { FormTemplate } from "components/modal/templates";
import { dateToView } from "helpers/date";
import React from "react";
import { apply, getItem } from "sources/books/counterpartyContracts";
import { config, initialState } from "./config";

class CounterpartyContractForm extends FormTemplate {
    sendRequest = (stateData) => {
        const { counterpartyId } = this.props;
        const data = { ...stateData, date: dateToView(stateData.date, "YYYY-MM-DD") };

        return apply({ counterpartyId, ...data }).then((res) => {
            if (!res) {
                return res;
            }

            const id = typeof res === "object" ? res.id : res;

            return id ? getItem({ counterpartyId, id }) : res;
        });
    };

    renderBodyInner = () => {
        const {
            isMain,
            number,
            date,
            name,
            legalPersonId,
            invoiceTriggerType,
            settlementCurrency,
            paymentPeriod,
            paymentPeriodType,
            paymentTypeId,
            debtCeiling,
            currentDebt,
        } = this.props.config;

        return (
            <>
                {this.renderCheckbox(isMain)}
                {this.renderField(number)}
                {this.renderDateField(date)}
                {this.renderField(name)}
                {this.renderSelect(legalPersonId)}
                {this.renderSelect(invoiceTriggerType)}
                {this.renderField(settlementCurrency)}
                {this.renderField(paymentPeriod)}
                {this.renderSelect(paymentPeriodType)}
                {this.renderSelect(paymentTypeId)}
                {this.renderField(debtCeiling)}
                {this.renderField(currentDebt)}
            </>
        );
    };
}

const ConfiguredModal = (props) => (
    <CounterpartyContractForm {...props} config={config} initialState={{ ...initialState, ...(props.data || {}) }} />
);

export default ConfiguredModal;
